import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from './modules/auth';
import data from './modules/data';

export default createStore({
  strict: true,
  modules: {
    auth,
    data,
  },
  // plugins: [createPersistedState()]
  plugins: [createPersistedState({
    reducer (val) {                                
      if(val.auth.isAuthenticated === false) { 
        return {}
      }
      return val
    }
  })]
});
